/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { rangeDependencies } from './dependenciesRange.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createColumnTransform } from '../../factoriesAny.js';
export var columnTransformDependencies = {
  IndexDependencies: IndexDependencies,
  matrixDependencies: matrixDependencies,
  rangeDependencies: rangeDependencies,
  typedDependencies: typedDependencies,
  createColumnTransform: createColumnTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesColumnTransform.generated.js
// module id = 1368
// module chunks = 0